export enum EMultiPostingAvailablePlatforms {
  None = 'None',
  All = 'All',
  Free = 'Free',
}

export interface IMultiPostingPlatformsByRegion {
  [key: string]: IMultiPostingPlatforms;
}

export interface IMultiPostingPlatforms {
  paid: string[];
  free: string[];
  descriptionAll?: string;
  descriptionFree?: string;
  important?: string[];
  importantFree?: string[];
}

export interface IMultiposting {
  enabled: boolean;
}
